<template>
  <div class="interface-echart">
    <div id="echart"></div>
  </div>
</template>

<script>
export default {
  props: {
    isMountedRender: {
      // 防止数据未获取就直接宣染dom
      type: Boolean,
      default: false,
    },
    xDataArray: {
      // 柱形图x轴数据
      type: Array,
      // eslint-disable-next-line vue/require-valid-default-prop
      default: ['<1秒', '1-5秒', '5-10秒', '10-30秒', '>30秒'],
    },
    yDataArray: {
      // 柱形图x轴数据
      type: Array,
      // eslint-disable-next-line vue/require-valid-default-prop
      default: [0, 0, 0, 0, 0],
    },
  },
  data() {
    return {
      myEchart: null,
    };
  },
  watch: {
    xDataArray: {
      handler() {
        this.myEchartData();
      },
      deep: true,
    },
    yDataArray: {
      handler() {
        this.myEchartData();
      },
      deep: true,
    },
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.handleResize);
  },
  mounted() {
    // console.log('dddd', this.xDataArray, this.yDataArray);
    this.myEchart = this.$echarts.init(document.getElementById('echart'));
    if (this.isMountedRender) {
      this.myEchartData();
    }
    // 当窗口发生变化时
    window.addEventListener('resize', this.handleResize);
  },
  methods: {
    myEchartData() {
      // const yData = this.yDataArray.map((item) => {
      //   if (item < 1) {
      //     // eslint-disable-next-line no-param-reassign
      //     item = {
      //       value: item,
      //       itemStyle: {
      //         color: '#3CFC07',
      //       },
      //     };
      //   }

      //   console.log(item);
      //   return item;
      // });
      // JSON.parse(JSON.stringify(this.yDataArray));
      // console.log(this.yDataArray, aa);
      const option = {
        // title: {
        //   text: '接口请求耗时分布', // 标题文字
        //   textStyle: {
        //     color: '#C0C4CC', // 标题样式设置
        //     fontWeight: 'bold', // 标题文字大小
        //   },
        // },
        grid: {
          right: 80,
          left: 50,
        },
        // legend: { right: 'auto' },
        tooltip: { trigger: 'axis' }, // 设置图案和容器的距离
        xAxis: {
          type: 'category',
          name: '接口时长',
          nameLocation: 'end',
          data: this.xDataArray,
        },
        yAxis: {
          type: 'value',
          name: '接口数',
          nameLocation: 'end',
          min: 0,
          splitLine: {
            show: false,
          },
          axisLine: { show: true },
          axisLabel: {
            formatter: '{value} ',
          },
        },
        series: [
          {
            name: '接口数量',
            type: 'bar',
            label: {
              // 柱状图上的文字设置
              show: true, // 是否显示
              //   rotate: 60, // 文字旋转角度
              position: 'top', // 显示位置
            },
            barWidth: '30%', // 柱的宽度
            barGap: '20%', // 多个并排柱子设置柱子之间的间距
            data: this.yDataArray,
            itemStyle: {
              // 颜色设置
              // normal: {
              color(params) {
                // console.log(params); // params数据项
                // 注意，如果颜色太少的话，后面颜色不会自动循环，最好多定义几个颜色
                const colorList = [
                  '#91CC75',
                  '#FAC858',
                  '#EDA402',
                  '#F47163',
                  '#F60404',
                ];
                  // 给大于颜色数量的柱体添加循环颜色的判断
                if (params.dataIndex >= colorList.length) {
                  // eslint-disable-next-line no-undef
                  index = params.dataIndex - colorList.length;
                }
                return colorList[params.dataIndex];
              },
              // },
            },
          },
        ],
      };
      if (this.xDataArray.length > 0) {
        this.myEchart.setOption(option);
      }
    },
    handleResize() {
      this.myEchart.resize();
    },
  },
};
</script>

<style lang="scss">
// .interface-echart {
//   height: 300px;
//   // width: 500px;
//   border: 1px solid #c0c4cc;
//   border-radius: 2%;
// }
#echart {
  height: 300px;
  // width: 500px;
}
</style>
